import Cookies from 'js-cookie';

import {
  COOKIE_ADCLICKID_ORDERED_LIST,
  URLPARAM_ADCLICKID_LIST,
} from '../global/constants';

export const getAdClickId = (): string | undefined => {
  for (const key of COOKIE_ADCLICKID_ORDERED_LIST) {
    const value = Cookies.get(key);
    if (value) {
      //_gcl_aw: GCL.1709134638.EAIaIQobChMI5dWEipDOhAMVxjqtBh1bOwDyEAAYASAAEgJ2TPD_BwE
      //_fbc: fb.1.1709200198561.IwAR1JHfIjIFF3JLU0EmkPZIFxDuvw-Cy_VanDHWbtTKcy8hBJR5gbQmnmM3c
      // also, some scenario might have only click id without the prefix
      return value.split('.').at(-1);
    }
  }
  //fallback to urlParams
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  for (const key of URLPARAM_ADCLICKID_LIST) {
    const value = urlParams.get(key);
    if (value) {
      return value;
    }
  }
  return undefined;
};
